export default __webpack_public_path__ + "static/media/logo_sj.3bd7810e.svg";